import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable, Subject, catchError, throwError } from 'rxjs';
import { GlobalServicesService } from './global-services.service';


@Injectable({
  providedIn: 'root'
})
export class LoginService {
  loginEmail: BehaviorSubject<string> = new BehaviorSubject<string>("");


  host_api_url = environment.HOST.HOST_API_URL;
  fast_api_url = environment.HOST.FAST_API_URL;

  public validToken = new Subject<any>();
  public privilege: any = {};
  constructor(private http: HttpClient,private globalService: GlobalServicesService) { }
  // metadataFastApi(): Observable<any> {
  //   return this.http.get(this.fast_api_url + '/metadata/company', this.options_fast_api());
  // }
  loginFastApi(payload: any): Observable<HttpResponse<any>> {
    const formData = new FormData();
    formData.append('email', payload.email.toLowerCase());
    formData.append('password', payload.password);
    formData.append('grant_type', 'password');
    
    // Add reCAPTCHA token if provided
    if (payload.recaptcha_token) {
      formData.append('recaptcha_token', payload.recaptcha_token);
    }
  
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/auth', formData, {
      observe: 'response'
    }).pipe(
      catchError((error) => throwError(() => error))
    );
  }
  // rest password fast api
  resetPasswordFastApi(reset_token: string, payload: any): Observable<HttpResponse<any>> {
    const params = new HttpParams()
      .set('reset_token', reset_token.toString());

    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/auth/reset-password`, payload, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  initiateSSOFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/auth/sso/initiate', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  ssoCallbackFastApi(payload: any): Observable<HttpResponse<any>> {
    const params = new HttpParams()
      .set('code', payload.code)
      .set('state', payload.state);
    
    if (payload.nonce) {
      params.set('nonce', payload.nonce);
    }
    
    if (payload.provider) {
      params.set('provider', payload.provider);
    }

    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/auth/sso/callback', {
      params,
      observe: 'response',
    }).pipe(
      catchError((error) => throwError(() => error))
    );
  }

}
